import { render, staticRenderFns } from "./InsuranceButton.vue?vue&type=template&id=ceb809c8&scoped=true&"
import script from "./InsuranceButton.vue?vue&type=script&lang=js&"
export * from "./InsuranceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb809c8",
  null
  
)

export default component.exports